import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { FetchProvider } from "./context/FetchContext";
import { ToastProvider } from "context/ToastContext";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Warehouses from "./pages/Warehouses";
import Users from "./pages/Users";
import Royaltys from "pages/Royaltys";
import Products from "pages/Products";
import SerialNumbers from "pages/SerialNumbers";
import DocumentsList from "components/documents/DocumentsList";

function App() {
  return (
    <AuthProvider>
      <FetchProvider>
        <ToastProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Layout />}>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="warehouses" element={<Warehouses />} />
                <Route path="royaltys" element={<Royaltys />} />
                <Route path="products" element={<Products />} />
                <Route path="serial-numbers" element={<SerialNumbers />} />
                <Route path="documents" element={<DocumentsList />} />
                <Route path="users" element={<Users />} />
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />
              </Route>
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Router>
        </ToastProvider>
      </FetchProvider>
    </AuthProvider>
  );
}

export default App;
